module.exports = __webpack_public_path__ + "static/media/C021.0da0c270.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C021.jpg
// module id = 304
// module chunks = 0